const NEW_USER_WINDOW_SECONDS = 180
const WELCOME_PENDING_USER_ID_KEY = 'glows_welcome_pending_user_id'
const WELCOME_SEEN_USER_IDS_KEY = 'glows_welcome_seen_user_ids'

function getSeenWelcomeUserIds(): number[] {
  try {
    const rawValue = localStorage.getItem(WELCOME_SEEN_USER_IDS_KEY)
    if (!rawValue) {
      return []
    }

    const parsedValue = JSON.parse(rawValue)
    return Array.isArray(parsedValue)
      ? parsedValue.filter((id): id is number => typeof id === 'number')
      : []
  } catch (error) {
    console.error('Failed to read welcome seen user ids:', error)
    return []
  }
}

export function isRecentlyCreatedUser(
  createTimeSeconds: number,
  nowSeconds = Math.floor(Date.now() / 1000),
) {
  return (
    createTimeSeconds > 0 &&
    nowSeconds >= createTimeSeconds &&
    nowSeconds - createTimeSeconds < NEW_USER_WINDOW_SECONDS
  )
}

export function isFirstLoginUser(createTimeSeconds: number, lastLoginAtSeconds: number) {
  return createTimeSeconds > 0 && lastLoginAtSeconds > 0 && createTimeSeconds === lastLoginAtSeconds
}

export function isNewUser(createTimeSeconds: number, lastLoginAtSeconds = 0) {
  return (
    isFirstLoginUser(createTimeSeconds, lastLoginAtSeconds) ||
    isRecentlyCreatedUser(createTimeSeconds)
  )
}

export function hasSeenWelcome(userId: number) {
  return getSeenWelcomeUserIds().includes(userId)
}

export function markWelcomePending(userId: number) {
  if (userId <= 0) {
    return
  }

  sessionStorage.setItem(WELCOME_PENDING_USER_ID_KEY, String(userId))
}

export function clearWelcomePending() {
  sessionStorage.removeItem(WELCOME_PENDING_USER_ID_KEY)
}

export function shouldShowWelcomeForUser(userId: number) {
  if (userId <= 0 || hasSeenWelcome(userId)) {
    return false
  }

  return sessionStorage.getItem(WELCOME_PENDING_USER_ID_KEY) === String(userId)
}

export function shouldShowWelcomeForNewUser(
  userId: number,
  createTimeSeconds: number,
  lastLoginAtSeconds = 0,
) {
  return userId > 0 && isNewUser(createTimeSeconds, lastLoginAtSeconds) && !hasSeenWelcome(userId)
}

export function markWelcomeSeen(userId: number) {
  if (userId <= 0) {
    return
  }

  const seenUserIds = getSeenWelcomeUserIds()
  if (!seenUserIds.includes(userId)) {
    localStorage.setItem(WELCOME_SEEN_USER_IDS_KEY, JSON.stringify([...seenUserIds, userId]))
  }

  if (sessionStorage.getItem(WELCOME_PENDING_USER_ID_KEY) === String(userId)) {
    clearWelcomePending()
  }
}

export function markWelcomePendingForNewUser(
  userId: number,
  createTimeSeconds: number,
  lastLoginAtSeconds: number,
  shouldRedirectToWelcome: boolean,
) {
  const isNewUserResult = isNewUser(createTimeSeconds, lastLoginAtSeconds)

  if (shouldRedirectToWelcome && isNewUserResult && !hasSeenWelcome(userId)) {
    markWelcomePending(userId)
  }

  return isNewUserResult
}
